import classNames from 'classnames';
import { type FC, type ReactNode } from 'react';
import { NavLink } from 'react-router';

interface MenuItemProps {
  link: string;
  icon?: ReactNode;
  children?: ReactNode;
  onClick?: () => void;
}

const MenuItem: FC<MenuItemProps> = ({ link, icon, onClick, children }) => {
  const navLinkClasses = ({ isActive }: { isActive: boolean }) => {
    return classNames(
      `flex gap-3 p-2 border border-transparent text-sm rounded-lg items-center cursor-pointer transition transition-bg duration-200 hover:text-primary`,
      {
        'bg-base-200/55 text-base-content border-1 border-base-100 text-primary': isActive,
      },
    );
  };

  return (
    <li>
      <NavLink
        to={link}
        className={({ isActive }) => navLinkClasses({ isActive })}
        onClick={onClick}
      >
        {icon && <span>{icon}</span>}
        {children && <span>{children}</span>}
      </NavLink>
    </li>
  );
};

export default MenuItem;
